<template>
  <div>
    <slot name="label">
      <FormLabel :aria-label="label" :for="id">
        <span>{{ label }}</span>
        <span v-if="required" class="required text-error pl-1">*</span>
      </FormLabel>
    </slot>
    <slot :id></slot>
  </div>
</template>

<script setup lang="ts">
import FormLabel from './FormLabel.vue'

defineProps({
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
})

const id = useId()
</script>

<style scoped>
.required {
  font-size: 1rem;
  line-height: 1;
}
</style>
